module.exports = __webpack_public_path__ + "img/index-manual-step-5@3x.fa9db65b.png";